import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import axios from 'axios';
import Config from '../../services/Config';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { errorHandling } from '../../helpers/common';

const AccountApplicationForm = () => {
  const { control, handleSubmit, watch, reset, register, setValue, formState: { errors } } = useForm();
  const [activeTab, setActiveTab] = useState('limitedCompany');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const selectedTradingName = watch('businessOperatorTradingName');

  useEffect(() => {
    reset();
  }, [activeTab]);

  const onSubmit = async (data) => {
    setLoading(true);
    const business_type = activeTab
    const company = [
      {
        name: data?.director1,
        postCode: data?.companyPostCode || "",
        companyRegistrationNumber: data?.companyRegNo || "",
      },
      {
        name: data.director2 || "",
      }
    ];

    // const formData = {
    //   ...data,
    //   company,
    //   business_type,
    // };
    // Create FormData object
    const formData = new FormData();

    // Append all fields to FormData
    Object.keys(data).forEach((key) => {
      // For file input
      if (key === 'signeeSignature' && data[key]?.[0]) {
        formData.append(key, data[key][0]);
      } else if (Array.isArray(data[key])) {
        // For array fields (like services_offered)
        data[key].forEach((val, idx) => {
          formData.append(`${key}[${idx}]`, val);
        });
      } else if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });

    // Append company and business_type as JSON/string
    formData.append('company', JSON.stringify(company));
    formData.append('business_type', business_type);

    try {
      // const response = await axios.post(`${Config.baseURL}${Config.accountApplication}`, formData);
      // toast.success(response?.data?.message || 'Save user application form successfully');
      // reset();
      // navigate('/login')
      const response = await axios.post(
        `${Config.baseURL}${Config.accountApplication}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      toast.success(response?.data?.message || 'Save user application form successfully');
      reset();
      navigate('/login');
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
      errorHandling(error);
    } finally {
      setLoading(false); // Set loading to false after data is fetched
    }
  };

  const servicesOffered = watch('services_offered') || [];
  const password = watch('password');

  return (
    <>
      <Helmet>
        <title>Account Application</title>
        <meta name="description" content="Account application form" />
      </Helmet>
      <div className="login_register">
        <div className="container">
          <div className="lrinner">
            <h1 className="mb-3 ">Account Application</h1>
            <div className="cart_recent_items pdTbs account_application pt-4">
              <p className="fs-6 mb-2">Please select the type of business</p>

              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'limitedCompany' ? 'active' : ''}`}
                    onClick={() => setActiveTab('limitedCompany')}
                    type="button"
                  >
                    Limited Company
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'soleProprietor' ? 'active' : ''}`}
                    onClick={() => setActiveTab('soleProprietor')}
                    type="button"
                  >
                    Sole Proprietor
                  </button>
                </li>
              </ul>

              <div className="tab-content">
                {(activeTab === 'limitedCompany' || activeTab === 'soleProprietor') && (
                  <div className="tab-pane fade show active" id="lc_tab">
                    <div className="common_form pt-3">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row gx-6 gy-4">
                          <div className="col-lg-6">
                            <div className="mb-3">
                              <h4>General Company Information</h4>
                              <p className="fs-6">Please provide your company details</p>
                            </div>

                            <div className="form_group">
                              <input
                                className="form-control"
                                placeholder="Business name in full*"
                                {...register('CardName', { required: true })}
                              />
                              {errors.CardName && <span style={{ color: '#eb3434' }}>Business name is required</span>}
                            </div>

                            <div className="form_group">
                              <input className="form-control" type="text" placeholder="Invoice Address*" {...register('AddressName', { required: true })} />
                              {errors.AddressName && <span style={{ color: '#eb3434' }}>Invoice Address is required</span>}
                            </div>
                            {/* <div className="form_group">
                              <input className="form-control" type="text" placeholder="Town/City" {...register('City')} />
                            </div> */}
                            {/* <div className="form_group">
                              <input className="form-control" type="text" placeholder="Post Code" {...register('ZipCode')} />
                            </div> */}
                            {/* <div className="form_group">
                              <input
                                // className={`form-control ${errors.ZipCode ? 'is-invalid' : ''}`}
                                 className="form-control"
                                type="text"
                                placeholder="Post Code"
                                maxLength={10}
                                {...register('ZipCode', {
                                  validate: {
                                    isValidPostcode: value =>
                                      value === '' || /^([A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}|GIR 0AA)$/.test(value) || 'Invalid postcode'
                                  }
                                })}
                              />
                              {errors.ZipCode && <span style={{ color: '#eb3434' }}>{errors.ZipCode.message}</span>}
                            </div> */}

                            <div className="form_group">
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Telephone*"
                                {...register('Phone1', {
                                  required: 'Telephone number is required',
                                  validate: {
                                    isNumeric: value => /^[0-9]*$/.test(value) || 'Only numeric values are allowed',
                                    minLength: value => value.length >= 10 || 'Telephone number must be at least 10 digits long',
                                    maxLength: value => value.length <= 15 || 'Telephone number cannot exceed 15 digits'
                                  }
                                })}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 15)} // Limit to 15 characters
                              />
                              {errors.Phone1 && <span style={{ color: '#eb3434' }}>{errors.Phone1.message}</span>}
                            </div>

                            <div className="form_group">
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Mobile"
                                {...register('Mobile', {
                                  required: false,
                                  validate: value => /^[0-9]*$/.test(value) || 'Only numeric values are allowed',
                                  minLength: value => value.length >= 10 || 'Phone number must be at least 10 digits long',
                                  maxLength: value => value.length <= 15 || 'Phone number cannot exceed 15 digits'
                                })}
                                onInput={(e) => e.target.value = e.target.value.slice(0, 15)} // Limit to 15 characters
                              />
                              {errors.Mobile && <span style={{ color: '#eb3434' }}>{errors.Mobile.message || 'Mobile number is required'}</span>}
                            </div>
                            {/* <div className="form_group">
                              <input className="form-control" type="text" placeholder="Delivery Address if Different from Invoice Address" {...register('Address')} />
                          </div> */}
                            <div className="form_group">
                              <input className="form-control" type="text" placeholder="Email*" {...register('EmailAddress', { required: true })} />
                              {errors.EmailAddress && <span style={{ color: '#eb3434' }}>Email is required</span>}
                            </div>
                            <div className="form_group">
                              <label className="mb-2">Does the business operate under a different trading name?</label>
                              <div>
                                <label className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value="yes"
                                    {...register('businessOperatorTradingName', { required: true })}
                                  />
                                  Yes
                                </label>
                                <label className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    value="no"
                                    {...register('businessOperatorTradingName', { required: true })}
                                  />
                                  No
                                </label>
                              </div>
                              {errors.businessOperatorTradingName && (
                                <span style={{ color: '#eb3434' }}>Please select Yes or No</span>
                              )}
                            </div>

                            {selectedTradingName === 'yes' && (
                              <div className="form_group">
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="State (In Full) *"
                                  {...register('State', { required: true })}
                                />
                                {errors.State && (
                                  <span style={{ color: '#eb3434' }}>State is required</span>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="col-lg-6">
                            <div>
                              <h4>Current Services Offered</h4>
                              <p className="fs-6">Please select all that apply, and at least one.</p>
                            </div>

                            <div className="row">

                              {errors.services_offered && <span style={{ color: '#eb3434' }}>{errors.services_offered.message}</span>}
                              {["Auto Locksmith", "Auto Spares/Supplies", "Builder Merchants", "Cash & Carry", "Dry Cleaners", "Engraver", "Hardware & DIY", "Ironmonger", "Key Cutter", "Locksmith", "Newsagent", "Other", "Property Management", "School/Local Authority", "Security", "Shoe Repairs", "Transponder Duplication", "Watch Repairs"].map(service => (
                                <div className="col-lg-6" key={service}>
                                  <div className="form-check custom_check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      {...register('services_offered', {
                                        validate: (value) => value.length > 0 || 'Please select at least one service',
                                      })}
                                      value={service}
                                      checked={servicesOffered.includes(service)}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (e.target.checked) {
                                          setValue('services_offered', [...servicesOffered, value], { shouldValidate: true });
                                        } else {
                                          setValue('services_offered', servicesOffered.filter((v) => v !== value), { shouldValidate: true });
                                        }
                                      }}
                                    />
                                    <label className="form-check-label">{service}</label>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div className="row gx-6 gy-4">
                          {activeTab === 'limitedCompany' && (
                            <div className="col-lg-6">
                              <h4>Director Information</h4>
                              <div className="form_group">
                                <input
                                  className="form-control"
                                  placeholder="Director 1*"
                                  {...register('director1', { required: true })}
                                />
                                {errors.director1 && <span style={{ color: '#eb3434' }}>Director 1 is required</span>}
                              </div>
                              <div className="form_group">
                                <input className="form-control" type="text" placeholder="Email Address of Director 1*" {...register('emailDirector1', { required: true })} />
                                {errors.emailDirector1 && <span style={{ color: '#eb3434' }}>Email Address of Director 1 is required</span>}
                              </div>
                              <div className="form_group">
                                <input className="form-control" type="text" placeholder="Director 2*" {...register('director2', { required: true })} />
                                {errors.director2 && <span style={{ color: '#eb3434' }}>Director 2 is required</span>}
                              </div>
                              <div className="form_group">
                                <input className="form-control" type="text" placeholder="Email Address of Director 2*" {...register('emailDirector2', { required: true })} />
                                {errors.emailDirector2 && <span style={{ color: '#eb3434' }}>Email Address of Director 2 is required</span>}
                              </div>
                            </div>
                          )}
                          {activeTab === 'soleProprietor' && (
                            <>
                              {/* <div className="row gx-6"> */}
                                <div className="col-lg-6">
                                  <h4>Sole Proprietor / Partnership Details</h4>
                                  <div className="form_group">
                                    <input
                                      type="text"
                                      // className={`form-control ${errors.names ? 'is-invalid' : ''}`}
                                      className="form-control"
                                      placeholder="Names*"
                                      {...register('names', { required: true })}
                                    />
                                    {errors.names && <span style={{ color: '#eb3434' }}>Name is required</span>}
                                  </div>
                                  <div className="form_group">
                                    <input type="text" className="form-control" placeholder="Private Address" {...register('city')} />
                                  </div>
                                  <div className="form_group">
                                    <input className="form-control" type="text" placeholder="Post Code" {...register('postCode')} />
                                  </div>
                                  {/* <div className="form_group">
                                    <input
                                      // className={`form-control ${errors.postCode ? 'is-invalid' : ''}`}
                                      className="form-control"
                                      type="text"
                                      placeholder="Post Code"
                                      maxLength={10}
                                      {...register('postCode', {
                                        validate: {
                                          isValidPostcode: value =>
                                            /^([A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}|GIR 0AA)$/.test(value) || 'Invalid Delivery postcode',
                                        }
                                      })} />
                                    {errors.postCode && <span style={{ color: '#eb3434' }}>{errors.postCode.message}</span>}
                                  </div> */}

                                  {/* <div className="form_group">
                                    <input type="text" className="form-control" placeholder="Post Code" {...register('postCode')} />
                                  </div> */}
                                </div>
                              {/* </div> */}
                            </>
                          )}
                          <div className="col-lg-6">
                            <h4>Delivery Details</h4>
                            <p className="fs-6">Please provide your delivery address if it differs from the main address above.</p>
                            <div className="form_group">
                              <input className="form-control" type="text" placeholder="Address" {...register('deliveryAddress')} />
                            </div>
                            <div className="form_group">
                              <input className="form-control" type="text" placeholder="City" {...register('deliveryCity')} />
                            </div>
                            <div className="form_group">
                              <input
                                    type="text"
                                    className="form-control"
                                    placeholder="EORI Number"
                                    {...register('eoriNumber', { required: false })}
                                  />
                                  {errors.eoriNumber && <span style={{ color: '#eb3434' }}>EORI Number is required</span>}
                            </div>
                            <div className="form_group">
                              <input
                                    type="text"
                                    className="form-control"
                                    placeholder="VAT Number"
                                    {...register('vatNumber', { required: false })}
                                  />
                                  {errors.vatNumber && <span style={{ color: '#eb3434' }}>VAT Number is required</span>}
                            </div>
                            <div className="form_group">
                              <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Delivery Notification Email*"
                                    {...register('deliveryNotificationEmail', { required: true })}
                                  />
                                  {errors.deliveryNotificationEmail && <span style={{ color: '#eb3434' }}>Delivery Notification Email is required</span>}
                            </div>
                            
                            {/* <div className="form_group">
                              <input className="form-control" type="text" placeholder="Post Code" {...register('deliveryPostCode')} />
                            </div> */}
                            {/* <div className="form_group">
                              <input
                                // className={`form-control ${errors.ZipCode ? 'is-invalid' : ''}`}
                                className="form-control"
                                type="text"
                                placeholder="Post Code"
                                maxLength={10}
                                {...register('deliveryPostCode', {
                                  validate: {
                                    isValidPostcode: value =>
                                      /^([A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}|GIR 0AA)$/.test(value) || 'Invalid Delivery postcode',
                                  }
                                })} />
                              {errors.deliveryPostCode && <span style={{ color: '#eb3434' }}>{errors.deliveryPostCode.message}</span>}
                            </div> */}
                          </div>
                        </div>
                        
                        <div className="row gx-6 gy-4">
                          <div className="col-lg-6">
                            <h4>Accounting details</h4>
                            <div className="form_group">
                              <input
                                type="input"
                                className="form-control"
                                placeholder="Contact Name*"
                                {...register('contactName', { required: true })}
                                />
                                {errors.contactName && <span style={{ color: '#eb3434' }}>Contact Name is required</span>}
                              </div>
                            <div className="form_group">
                              <input
                                type="input"
                                className="form-control"
                                placeholder="Email for statements*"
                                {...register('emailForStatements', { required: true })}
                                />
                                {errors.emailForStatements && <span style={{ color: '#eb3434' }}>Email for statements is required</span>}
                              </div>
                              <div className="form_group">
                              <input
                                type="input"
                                className="form-control"
                                placeholder="Email for invoices*"
                                {...register('emailForInvoices', { required: true })}
                                />
                                {errors.emailForInvoices && <span style={{ color: '#eb3434' }}>Email for invoices is required</span>}
                              </div>
                              <div className="form_group">
                              <input
                                type="input"
                                className="form-control"
                                placeholder="Accounts Telephone*"
                                {...register('accountsTelephone', { required: true })}
                                />
                                {errors.accountsTelephone && <span style={{ color: '#eb3434' }}>Accounts Telephone is required</span>}
                              </div>
                          </div>
                          <div className="col-lg-6">
                            <h4>Clearing Agent Details <span style={{ fontSize: '0.8em' }}>(For pallet delivery only if specific)</span></h4>
                            <div className="form_group">
                              <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Company Name"
                                    {...register('companyName', { required: false })}
                                  />
                                  {errors.companyName && <span style={{ color: '#eb3434' }}>Company Name is required</span>}
                            </div>
                            <div className="form_group">
                              <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Contact"
                                    {...register('contact', { required: false })}
                                  />
                                  {errors.contact && <span style={{ color: '#eb3434' }}>Contact is required</span>}
                            </div>
                            <div className="form_group">
                              <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Telephone Number"
                                    {...register('telephoneNumber', { required: false })}
                                  />
                                  {errors.telephoneNumber && <span style={{ color: '#eb3434' }}>Telephone Number is required</span>}
                            </div>
                            <div className="form_group">
                              <input className="form-control" type="text" placeholder="Email Address" {...register('AgentEmailAddress', { required: false })} />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <h4>User Login Details</h4>
                            <div className="form_group">
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Email*"
                                {...register('email', { required: true })}
                                />
                                {errors.email && <span style={{ color: '#eb3434' }}>Email is required</span>}
                              </div>
                              <div className="form_group">
                                <label className="mb-2">Back orders Accepted</label>
                                <div>
                                <label className="form-check form-check-inline">
                                  <input
                                  className="form-check-input"
                                  type="radio"
                                  value="yes"
                                  {...register('backOrdersAccepted', { required: true })}
                                  />
                                  Yes
                                </label>
                                <label className="form-check form-check-inline">
                                  <input
                                  className="form-check-input"
                                  type="radio"
                                  value="no"
                                  {...register('backOrdersAccepted', { required: true })}
                                  />
                                  No
                                </label>
                                </div>
                                {errors.backOrdersAccepted && (
                                <span style={{ color: '#eb3434' }}>Please select Yes or No</span>
                                )}
                              </div>
                              {/* Back orders Accepted YES/NO **Circle as appropriate** */}
                            {/* <div className="form_group">
                              <input
                                type="password"
                                // className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                className="form-control"
                                placeholder="Password"
                                {...register('password', { required: true })}
                              />
                              {errors.password && <span style={{ color: '#eb3434' }}>Password is required</span>}
                            </div>
                            <div className="form_group">
                              <input
                                type="password"
                                className="form-control"
                                placeholder="Confirm Password"
                                {...register('confirmPassword', {
                                  required: true,
                                  validate: (value) => value === password || 'Passwords do not match',
                                })}
                              />
                              {errors.confirmPassword && (
                                <span style={{ color: '#eb3434' }}>
                                  {errors.confirmPassword.type === 'required'
                                    ? 'Confirm password is required'
                                    : errors.confirmPassword.message}
                                </span>
                              )}
                            </div> */}
                          </div>
                          {/* <div className="col-lg-6">
                          <h4>Trade References</h4>
                          <div className="form_group">
                            <input className="form-control" type="text" placeholder="Trade Ref 1" {...register('tradeRef1')} />
                          </div>
                          <div className="form_group">
                            <input className="form-control" type="text" placeholder="Trade Ref 2" {...register('tradeRef2')} />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <h4>Applicant Details</h4>
                          <div className="form_group">
                            <input className="form-control" type="text" placeholder="Name" {...register('applicantName')} />
                          </div>
                          <div className="form_group">
                            <input className="form-control" type="text" placeholder="Position" {...register('applicantPosition')} />
                          </div>
                        </div> */}
                        </div>

                        <div className="col-lg-12">
                          <h4 style={{ textAlign: 'center' }}>Declaration</h4>
                          <div className='col-lg-12' style={{ textAlign: 'center', textDecoration: 'underline' }}><strong>**Please declare and sign**</strong></div>
                          <div className="form-check custom_check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              {...register('termsAccepted', { required: true })}
                            />
                            <label className="form-check-label">I CONFIRM ALL INFORMATION I HAVE PROVIDED IS TRUE AND CORRECT (PLEASE TICK)</label><br />
                            {errors.termsAccepted && <span style={{ color: '#eb3434' }}>You must accept the terms and conditions</span>}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <table className="table table-bordered">
                            <tbody>
                              <tr>
                                <td rowSpan={2} style={{ backgroundColor: '#f2f2f2', verticalAlign: 'middle', fontWeight: 'bold', fontSize: '20px' }}>
                                  Details of Signee
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Name (Print)"
                                    {...register('signeeName', { required: true })}
                                  />
                                  {errors.signeeName && (
                                    <span style={{ color: '#eb3434' }}>Name is required</span>
                                  )}
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Position"
                                    {...register('signeePosition', { required: false })}
                                  />
                                  {errors.signeePosition && (
                                    <span style={{ color: '#eb3434' }}>Position is required</span>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    className="form-control"
                                    {...register('signeeSignature', { required: false })}
                                  />
                                  {errors.signeeSignature && (
                                    <span style={{ color: '#eb3434' }}>Signature is required</span>
                                  )}
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="Date"
                                    defaultValue={new Date().toISOString().split('T')[0]}
                                    {...register('signeeDate', { required: false })}
                                  />
                                  {errors.signeeDate && (
                                    <span style={{ color: '#eb3434' }}>Date is required</span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="login_btn mt-4 pt-3">
                          <button className={`button2 ${loading ? 'disabled' : ''}`} type="submit" disabled={loading}>
                            {loading ? ('Loading...') : ('Send Application')}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default AccountApplicationForm;
